// extracted by mini-css-extract-plugin
module.exports = {"vPrimary3":"#4f47d7","showAll":"StoreOrderPickup_showAll__3Ddla","modalBody":"StoreOrderPickup_modalBody__bo4ZL"};